<script setup>
import {Head, Link, useForm} from '@inertiajs/vue3';
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue';
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue';
import JetButton from '@/Jetstream/Button.vue';
import JetInput from '@/Jetstream/Input.vue';
import JetLabel from '@/Jetstream/Label.vue';
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue';

defineProps({
  status: String,
});

const form = useForm({
  email: '',
});

const submit = () => {
  form.post(route('password.email'));
};
</script>

<template>
  <Head :title="$t('Forgot Password')"/>

  <JetAuthenticationCard>
    <template #logo>
      <JetAuthenticationCardLogo/>
    </template>

    <div class="mb-4 text-sm text-gray-600">
      {{ $t('Forgot your password? No problem. Just let us know your email address and we will email you a password reset link that will allow you to choose a new one.') }}
    </div>

    <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
      {{ status }}
    </div>

    <JetValidationErrors class="mb-4"/>

    <form @submit.prevent="submit">
      <div>
        <JetLabel for="email" :value="$t('Email')"/>
        <JetInput
            id="email"
            v-model="form.email"
            type="email"
            class="mt-1 block w-full"
            required
            autofocus
        />
      </div>

      <div class="flex flex-col items-start mt-4">
        <JetButton class="mb-4"  :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
          {{ $t('Email Password Reset Link') }}
        </JetButton>

        <Link :href="route('login')"
              class="underline text-sm text-gray-600 hover:text-gray-900">
          {{ $t('Back to Login') }}
        </Link>
      </div>

    </form>
  </JetAuthenticationCard>
</template>
